import React, { useState } from 'react';
import { Drawer, Box, Pagination, ButtonGroup } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { useQuery } from '@apollo/client/react';
import { FilterProvider, useFilter, initTemplateFilterValues } from 'contexts/filter';
import { useError } from 'contexts/error';
import { usePaginate } from 'contexts/paginate';
import FilterForm from 'components/template/filter_form';
import FilterTags from 'components/filter/tags';
import InfoContainer from 'components/info_container';
import CreateButton from 'components/template/button/create';
import TemplatesQuery from 'queries/template/index';
import Index from 'components/template/index';
import FilterButton from 'components/template/button/filter';

const IndexContainer = () => {
  const { page, onPageChange } = usePaginate();
  const setError = useError();
  const { templatesFilter, setTemplatesFilter } = useFilter();
  const [filterVisible, setFilterVisible] = useState(false);
  const [sortBy, setSortBy] = useState('name_asc');
  const { data = { templates: { templates: [], perPage: 10 }, space: { adminRole: true } }, loading } = useQuery(
    TemplatesQuery,
    {
      variables: {
        ...templatesFilter,
        page: page,
        sortBy: sortBy,
      },
      onError: () => {
        setError('error.template.index');
      },
    }
  );

  return (
    <FilterProvider>
      {filterVisible && (
        <Drawer
          anchor="right"
          open={filterVisible}
          onClose={() => {
            setFilterVisible(false);
          }}
        >
          <FilterForm
            initialValues={templatesFilter}
            defaultValues={initTemplateFilterValues}
            onSubmit={(values) => {
              onPageChange(1);
              setTemplatesFilter(values);
            }}
            onClose={() => {
              setFilterVisible(false);
            }}
          />
        </Drawer>
      )}
      <Box display="flex" justifyContent="flex-end">
        <ButtonGroup>
          <CreateButton disabled={!data.space.adminRole} />
          <FilterButton
            onClick={() => setFilterVisible(!filterVisible)}
            initTemplateFilterValues={initTemplateFilterValues}
            templatesFilter={templatesFilter}
          />
        </ButtonGroup>
      </Box>
      <FilterTags
        filterValues={templatesFilter}
        defaultValues={initTemplateFilterValues}
        onFilterChange={setTemplatesFilter}
      />
      <InfoContainer visible={!loading && data.templates.templatesTotal === 0}>
        <FormattedMessage id="empty.templates.title" />
      </InfoContainer>
      <Index
        loading={loading}
        templates={data.templates}
        sortBy={sortBy}
        onSortChange={setSortBy} />
      <Box display="flex" justifyContent="center">
        {data.templates.templatesTotalPages > 1 && (
          <Pagination
            count={data.templates.templatesTotalPages}
            page={page}
            onChange={(_e, nextPage) => {
              onPageChange(nextPage);
            }}
          />
        )}
      </Box>
    </FilterProvider>
  );
};

export default IndexContainer;
